import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-4 flex items-center gap-3 relative z-10"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "text-sm font-semibold text-white truncate" }
const _hoisted_4 = {
  key: 1,
  class: "text-sm font-semibold text-white truncate"
}
const _hoisted_5 = { class: "creation__content-wrapper" }
const _hoisted_6 = { class: "creation__content" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "creation__name" }
const _hoisted_9 = { class: "creation__label" }
const _hoisted_10 = { class: "creation__bubble" }
const _hoisted_11 = { class: "flex flex-col gap-2.5 w-full pt-2" }
const _hoisted_12 = { class: "flex font-medium text-[13px] leading-none" }
const _hoisted_13 = { class: "flex-1" }
const _hoisted_14 = { class: "flex-1 text-right" }
const _hoisted_15 = { class: "flex gap-px w-full" }
const _hoisted_16 = ["for"]
const _hoisted_17 = ["id", "value"]
const _hoisted_18 = { class: "p-4 flex justify-end relative z-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrandImageComponent = _resolveComponent("BrandImageComponent")!
  const _component_FullHeaderComponent = _resolveComponent("FullHeaderComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["creation__container", { 'creation__container--background': _ctx.showBackgroundImage }]),
    style: _normalizeStyle({backgroundImage: _ctx.backgroundImageURL ? `url(${_ctx.backgroundImageURL})` : 'none'})
  }, [
    (_ctx.showBackgroundImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_BrandImageComponent, {
            class: "w-10 h-10",
            campaign: _ctx.campaign
          }, null, 8, ["campaign"]),
          (_ctx.campaign.profile.brandLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "link",
                href: _ctx.campaign.profile.brandLink,
                target: "_blank"
              }, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.campaign.profile.name || _ctx.campaign.profile.url), 1)
              ], 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.campaign.profile.name || _ctx.campaign.profile.url), 1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (!_ctx.showBackgroundImage)
            ? (_openBlock(), _createBlock(_component_FullHeaderComponent, {
                key: 0,
                campaign: _ctx.campaign
              }, null, 8, ["campaign"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["text-center w-full text-creation-on-background", { 'bg-black/20 backdrop-blur-2xl px-4 py-2 rounded-t-2xl': _ctx.showBackgroundImage, 'mb-5': !_ctx.showBackgroundImage }])
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.campaign.profile.name || _ctx.campaign.profile.url), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('creation.NPSBubbleLabel')), 1)
          ], 2),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.campaign.NPSQuestion)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.campaign.NPSQuestion), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.defaultNPSQuestion), 1)
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", {
                class: _normalizeClass(["text-creation-on-background", { 'inline-flex bg-black/20 backdrop-blur-2xl rounded-md p-1': _ctx.showBackgroundImage }])
              }, _toDisplayString(_ctx.$t('creation.NPSNotLikelyLabel')), 3)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", {
                class: _normalizeClass(["text-creation-on-background", { 'inline-flex bg-black/20 backdrop-blur-2xl rounded-md p-1': _ctx.showBackgroundImage }])
              }, _toDisplayString(_ctx.$t('creation.NPSVeryLikelyLabel')), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], (i) => {
              return _createElementVNode("label", {
                key: i,
                for: `rating${i}`,
                class: "flex-1 cursor-pointer select-none"
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: `rating${i}`,
                  name: "rating",
                  value: i,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rating) = $event)),
                  class: "sr-only peer"
                }, null, 8, _hoisted_17), [
                  [_vModelRadio, _ctx.rating]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center justify-center flex-shrink-0 h-[30px] rounded-[4px] font-bold text-creation-on-background peer-checked:bg-creation-primary peer-checked:text-creation-on-primary", {
                                    'bg-black/20 backdrop-blur-2xl': _ctx.showBackgroundImage,
                                    'bg-creation-on-background/creation-circle1': !_ctx.showBackgroundImage,
                                }])
                }, _toDisplayString(i), 3)
              ], 8, _hoisted_16)
            }), 64))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        class: _normalizeClass(["button button--large button--wider shadow bg-creation-primary text-creation-on-primary", { 'button--disabled': !_ctx.canSubmit }]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToPromptScreen && _ctx.goToPromptScreen(...args)))
      }, _toDisplayString(_ctx.$t('creation.continueButtonLabel')), 3)
    ]),
    _createVNode(_component_FooterComponent, {
      campaign: _ctx.campaign,
      showBackgroundImage: _ctx.showBackgroundImage
    }, null, 8, ["campaign", "showBackgroundImage"])
  ], 6))
}